import { environment } from '@/environments/environment'

export default [
  { name: 'getDefaultAnswer', url: `${environment.torontoApiUrl}/ticket-answers`, method: 'get' },
  { name: 'updateAnswer', url: `${environment.torontoApiUrl}/ticket-answers/{id}`, method: 'put' },
  { name: 'createAnswer', url: `${environment.torontoApiUrl}/ticket-answers`, method: 'post' },
  { name: 'deleteAnswer', url: `${environment.torontoApiUrl}/ticket-answers/{id}`, method: 'delete' }
]